/* SOFTANA theme scripts: licence finder, edition filter, product tabs */
(function () {
  'use strict';
  const money = (cents, fmt) => {
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    const withCommas = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const euro = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (fmt || '{{amount}}')
      .replace('{{amount_with_comma_separator}}', euro + ',' + d)
      .replace('{{amount_no_decimals_with_comma_separator}}', euro)
      .replace('{{amount_with_apostrophe_separator}}', i.replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + d)
      .replace('{{amount_with_space_separator}}', i.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + d)
      .replace('{{amount_no_decimals_with_space_separator}}', i.replace(/\B(?=(\d{3})+(?!\d))/g, ' '))
      .replace('{{amount_no_decimals}}', withCommas)
      .replace('{{amount}}', withCommas + '.' + d);
  };

  /* ---------- Licence finder ---------- */
  document.querySelectorAll('[data-mx-finder]').forEach((root) => {
    let data = [];
    try { data = JSON.parse(root.querySelector('script[type="application/json"]').textContent) || []; } catch (e) { return; }
    if (!data.length) { root.hidden = true; return; }
    const fmt = root.dataset.moneyFormat || '{{amount}}';
    const dims = ['edition', 'platform', 'region', 'year', 'users'];
    const state = {};
    const segs = {};
    dims.forEach((d) => { segs[d] = root.querySelector('[data-seg="' + d + '"]'); });

    const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)));
    const optionsFor = (d) => {
      if (d === 'users') return uniq(data.flatMap((p) => p.variants.map((v) => v.title)));
      return uniq(data.map((p) => p[d]));
    };
    const order = { edition: ['Pro', 'Premier', 'Enterprise', 'Enterprise Accountant'], platform: ['Windows', 'Mac'], region: ['USA', 'Canada'] };
    const sortBy = (d, arr) => {
      if (d === 'users') return arr.sort((a, b) => parseInt(a) - parseInt(b));
      if (d === 'year') return arr.sort((a, b) => parseInt(b) - parseInt(a)); // newest first
      const o = order[d] || [];
      return arr.sort((a, b) => (o.indexOf(a) === -1 ? 99 : o.indexOf(a)) - (o.indexOf(b) === -1 ? 99 : o.indexOf(b)));
    };
    const pdims = dims.filter((d) => d !== 'users');

    dims.forEach((d) => {
      if (!segs[d]) return;
      const opts = sortBy(d, optionsFor(d));
      if (opts.length < 2 && d !== 'users') { segs[d].closest('.mx-finder__row').hidden = true; state[d] = opts[0] || null; return; }
      segs[d].innerHTML = '';
      opts.forEach((o, i) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'mx-seg__btn'; b.dataset.value = o; b.textContent = o;
        b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        b.addEventListener('click', () => { state[d] = o; render(d); });
        segs[d].appendChild(b);
      });
      state[d] = opts[0];
    });

    const matches = (skip) => data.filter((p) => pdims.every((d) => d === skip || !state[d] || p[d] === state[d]));

    // Resolve the current selection to one product. The dimension the user just clicked is kept;
    // the others are kept when possible, otherwise relaxed in priority order (edition > platform > region > year).
    function resolve(clicked) {
      let cands = clicked ? data.filter((p) => p[clicked] === state[clicked]) : data.slice();
      if (!cands.length) cands = data.slice();
      pdims.forEach((d) => {
        if (d === clicked) return;
        const narrowed = cands.filter((p) => p[d] === state[d]);
        if (narrowed.length) cands = narrowed;
      });
      const p = cands[0];
      if (p) pdims.forEach((d) => { state[d] = p[d]; });
      return p;
    }

    function render(clicked) {
      const p = resolve(clicked);
      // enable/disable buttons per dimension based on the other selections
      pdims.forEach((d) => {
        if (!segs[d]) return;
        const avail = uniq(matches(d).map((x) => x[d]));
        segs[d].querySelectorAll('.mx-seg__btn').forEach((b) => {
          b.disabled = !avail.includes(b.dataset.value);
          b.setAttribute('aria-pressed', state[d] === b.dataset.value ? 'true' : 'false');
        });
      });
      const res = root.querySelector('[data-result]');
      const empty = root.querySelector('[data-empty]');
      if (!p) { res.hidden = true; empty.hidden = false; return; }
      res.hidden = false; empty.hidden = true;
      // users
      if (segs.users) {
        const titles = p.variants.map((v) => v.title);
        segs.users.querySelectorAll('.mx-seg__btn').forEach((b) => {
          const ok = titles.includes(b.dataset.value);
          b.disabled = !ok;
        });
        if (!titles.includes(state.users)) state.users = titles[0];
        segs.users.querySelectorAll('.mx-seg__btn').forEach((b) => b.setAttribute('aria-pressed', state.users === b.dataset.value ? 'true' : 'false'));
      }
      const v = p.variants.find((x) => x.title === state.users) || p.variants[0];
      root.querySelector('[data-r-title]').textContent = p.title;
      root.querySelector('[data-r-meta]').textContent = [p.platform, p.region, p.year ? p.year + ' edition' : null, 'Lifetime licence'].filter(Boolean).join(' · ');
      const img = root.querySelector('[data-r-img]');
      if (img) { img.src = p.image || ''; img.alt = p.title; img.hidden = !p.image; }
      root.querySelector('[data-r-price]').firstChild.textContent = v.price_fmt || money(v.price, fmt);
      const cmp = root.querySelector('[data-r-compare]');
      if (cmp) { cmp.textContent = v.compare_fmt || ''; }
      const a = root.querySelector('[data-r-link]');
      a.href = p.url + '?variant=' + v.id;
      const cta = root.querySelector('[data-r-cta]');
      if (cta) cta.href = a.href;
      const sub = root.querySelector('[data-r-sub]');
      if (sub) sub.textContent = v.title + ' · one-time payment';
    }
    render();
  });

  /* ---------- Edition filter (country / platform / version / year) ---------- */
  const FLAGS = {
    USA: '<svg class="mx-flag" viewBox="0 0 30 20" aria-hidden="true"><rect width="30" height="20" fill="#fff"/><path d="M0 0h30v1.54H0zM0 3.08h30v1.54H0zM0 6.15h30v1.54H0zM0 9.23h30v1.54H0zM0 12.31h30v1.54H0zM0 15.38h30v1.54H0zM0 18.46h30V20H0z" fill="#B22234"/><rect width="13" height="10.77" fill="#3C3B6E"/><g fill="#fff"><circle cx="2.2" cy="2" r=".55"/><circle cx="5.4" cy="2" r=".55"/><circle cx="8.6" cy="2" r=".55"/><circle cx="11" cy="2" r=".55"/><circle cx="3.8" cy="4.2" r=".55"/><circle cx="7" cy="4.2" r=".55"/><circle cx="10" cy="4.2" r=".55"/><circle cx="2.2" cy="6.4" r=".55"/><circle cx="5.4" cy="6.4" r=".55"/><circle cx="8.6" cy="6.4" r=".55"/><circle cx="11" cy="6.4" r=".55"/><circle cx="3.8" cy="8.6" r=".55"/><circle cx="7" cy="8.6" r=".55"/><circle cx="10" cy="8.6" r=".55"/></g></svg>',
    Canada: '<svg class="mx-flag" viewBox="0 0 30 20" aria-hidden="true"><rect width="30" height="20" fill="#fff"/><path d="M0 0h7.5v20H0zM22.5 0H30v20h-7.5z" fill="#D52B1E"/><path d="M15 3l1.2 2.4 1.4-.7-.5 3 1.9-1.9.4 1.1 1.8-.4-.6 2 .9.5-3.2 2.6.3 1.2-3.2-.4V15h-.8v-2.6l-3.2.4.3-1.2-3.2-2.6.9-.5-.6-2 1.8.4.4-1.1 1.9 1.9-.5-3 1.4.7z" fill="#D52B1E"/></svg>'
  };
  const ICON = {
    Windows: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M3 5.5 11 4.3v7.2H3V5.5zM12 4.2 21 3v8.5h-9V4.2zM3 12.5h8v7.2L3 18.5v-6zM12 12.5h9V21l-9-1.3v-7.2z"/></svg>',
    Mac: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M16.5 12.8c0-2.4 2-3.5 2-3.5-1.1-1.6-2.8-1.8-3.4-1.9-1.5-.1-2.8.9-3.5.9s-1.9-.9-3.1-.9C6.8 7.5 5 8.8 4.1 10.6c-1.7 3-.4 7.4 1.2 9.8.8 1.2 1.8 2.5 3 2.4 1.2 0 1.7-.8 3.1-.8s1.9.8 3.1.8c1.3 0 2.1-1.2 2.9-2.4.9-1.3 1.3-2.6 1.3-2.7-.1 0-2.2-.9-2.2-4.9zM14 5.6c.6-.8 1.1-1.9 1-3-.9 0-2.1.6-2.8 1.4-.6.7-1.1 1.8-1 2.9 1 .1 2.1-.5 2.8-1.3z"/></svg>'
  };
  const ORDER = {
    region: ['USA', 'Canada'],
    platform: ['Windows', 'Mac'],
    edition: ['Pro', 'Premier', 'Enterprise', 'Enterprise Accountant']
  };
  document.querySelectorAll('[data-mx-filter]').forEach((root) => {
    const cards = Array.from(root.querySelectorAll('[data-card]'));
    const dims = ['region', 'platform', 'edition', 'year'];
    const bar = root.querySelector('[data-filter-bar]');
    if (!bar || !cards.length) return;
    const more = root.querySelector('[data-filter-more]');
    const countEl = bar.querySelector('[data-filter-count]');
    const reset = bar.querySelector('[data-filter-reset]');
    const empty = root.querySelector('[data-filter-empty]');
    const fresh = () => ({ region: null, platform: null, edition: null, year: null });
    let active = fresh();
    let expanded = false;
    const vals = {};
    const sortVals = (d, list) => {
      if (d === 'year') return list.sort((x, y) => Number(y) - Number(x));
      const o = ORDER[d] || [];
      return list.sort((x, y) => (o.indexOf(x) < 0 ? 99 : o.indexOf(x)) - (o.indexOf(y) < 0 ? 99 : o.indexOf(y)) || x.localeCompare(y));
    };
    const btns = {};
    let groupsShown = 0;
    dims.forEach((d) => {
      vals[d] = sortVals(d, Array.from(new Set(cards.map((c) => c.dataset[d]).filter(Boolean))));
      const group = bar.querySelector('[data-group="' + d + '"]');
      if (!group) return;
      if (vals[d].length < 2) { group.hidden = true; return; }
      groupsShown++;
      const opts = group.querySelector('.mx-fgroup__opts');
      btns[d] = [];
      [null].concat(vals[d]).forEach((v) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'mx-fopt'; b.dataset.value = v === null ? '' : v;
        const lead = v === null ? '' : (d === 'region' && FLAGS[v]) || (d === 'platform' && ICON[v]) || '';
        b.innerHTML = lead + '<span>' + (v === null ? 'All' : v) + '</span>' + (v === null ? '' : '<em class="mx-fopt__n"></em>');
        b.addEventListener('click', () => { active[d] = v; apply(); });
        opts.appendChild(b); btns[d].push(b);
      });
    });
    if (!groupsShown) return;
    bar.hidden = false;
    if (reset) reset.addEventListener('click', () => { active = fresh(); apply(); });
    if (more) more.addEventListener('click', () => { expanded = true; apply(); });
    // preselect from ?filter=pro|windows|usa|2024 and ?country= / ?platform= / ?version= / ?year=
    try {
      const sp = new URLSearchParams(location.search);
      const pick = (d, q) => { q = (q || '').toLowerCase(); const m = vals[d].find((v) => v.toLowerCase() === q); if (m) active[d] = m; };
      const q = sp.get('filter'); if (q) dims.forEach((d) => pick(d, q));
      pick('region', sp.get('country')); pick('platform', sp.get('platform')); pick('edition', sp.get('version')); pick('year', sp.get('year'));
    } catch (e) {}
    const match = (c, skip) => dims.every((d) => d === skip || !active[d] || c.dataset[d] === active[d]);
    function apply() {
      const any = dims.some((d) => active[d]);
      Object.keys(btns).forEach((d) => btns[d].forEach((b) => {
        const v = b.dataset.value || null;
        b.setAttribute('aria-pressed', active[d] === v ? 'true' : 'false');
        if (v === null) return;
        const n = cards.filter((c) => match(c, d) && c.dataset[d] === v).length;
        b.querySelector('.mx-fopt__n').textContent = n;
        b.disabled = n === 0 && active[d] !== v;
      }));
      let shown = 0;
      cards.forEach((c) => {
        const ok = match(c) && (any || expanded || !c.hasAttribute('data-extra'));
        c.hidden = !ok; if (ok) shown++;
      });
      const total = cards.filter((c) => match(c)).length;
      if (more) more.parentElement.hidden = any || expanded;
      if (countEl) countEl.innerHTML = any ? 'Showing <b>' + total + '</b> of ' + cards.length + ' licences' : '<b>' + cards.length + '</b> licences · lifetime, one-time payment';
      if (reset) reset.hidden = !any;
      if (empty) empty.hidden = shown > 0;
    }
    apply();
  });

  /* ---------- Product tabs ---------- */
  document.querySelectorAll('[data-mx-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('.mx-tab');
    const panels = root.querySelectorAll('.mx-panel');
    tabs.forEach((t, i) => t.addEventListener('click', () => {
      tabs.forEach((x, j) => x.setAttribute('aria-selected', i === j ? 'true' : 'false'));
      panels.forEach((p, j) => { p.hidden = i !== j; });
    }));
  });
})();
